import { computed } from "vue";
import { useBreakpoints, breakpointsTailwind, useWindowSize } from "@vueuse/core";

export function useResponsive() {
    const breakpoints = useBreakpoints(breakpointsTailwind);
    const { width: windowWidth, height: windowHeight } = useWindowSize();

    const isMobile = computed(() => breakpoints.smaller("md").value);
    const isTablet = computed(() => breakpoints.between("md", "lg").value);
    const isDesktop = computed(() => breakpoints.greaterOrEqual("lg").value);
    const isSmallScreen = computed(() => breakpoints.smaller("lg").value);
    const isLargeScreen = computed(() => breakpoints.greaterOrEqual("xl").value);

    const currentBreakpoint = computed(() => {
        if (breakpoints.smaller("sm").value) return "xs";
        if (breakpoints.smaller("md").value) return "sm";
        if (breakpoints.smaller("lg").value) return "md";
        if (breakpoints.smaller("xl").value) return "lg";
        if (breakpoints.smaller("2xl").value) return "xl";
        return "2xl";
    });

    const screenWidth = computed(() => windowWidth.value);
    const screenHeight = computed(() => windowHeight.value);

    return {
        isMobile,
        isTablet,
        isDesktop,
        isSmallScreen,
        isLargeScreen,
        currentBreakpoint,
        screenWidth,
        screenHeight,
        breakpoints,
    };
}
